var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"checkBox",class:[
    {
      'checkBox--active': _vm.inputValue,
      isPC: !_vm.isMobile,
    },
  ],style:({
    '--size': _vm.size + 'px',
    '--color': _vm.color
  }),attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.changeCheckbox.apply(null, arguments)}}},[_vm._t("before"),_c('v-icon',{staticClass:"checkBox__check",class:{ 'checkBox__check--active': _vm.inputValue }},[_vm._v(" mdi-check-bold ")]),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }